import { Box, Flex, Skeleton } from '@chakra-ui/react';
import assert from 'assert';
import React from 'react';

import { useGetUserQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import { BorrowerHeader } from 'borrower/domains/page/ui/BorrowerHeader';
import { BorrowerSideBar } from 'borrower/domains/page/ui/SideBar';
import 'borrower/borrower.scss';
import CreditFacilityProvider from 'packages/credit-facility/hooks/CreditFacilityProvider';
import CreditFacilityMissingFallback from 'packages/credit-facility/ui/CreditFacilityMissingFallback';

export const BorrowerTemplate: React.FC = ({ children }) => {
  const { data, loading } = useGetUserQuery();
  if (!data || loading) {
    return <Skeleton data-testid="loading-borrower-router" height="600px" />;
  }

  const { user } = data;
  assert(user, 'User expected to exist');

  const { organizationId } = user;

  return (
    <>
      <BorrowerHeader />
      <Flex minH="95vh" grow={1} pt="84px">
        <CreditFacilityProvider
          organizationId={organizationId}
          renderLoading={<Skeleton />}
          fallbackComponent={<CreditFacilityMissingFallback />}
        >
          <BorrowerSideBar userData={data} />
          <Box padding="32px" width="100%" overflowX="auto">
            {children}
          </Box>
        </CreditFacilityProvider>
      </Flex>
    </>
  );
};
